// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"RichText_paragraph__ggNxi","bold":"RichText_bold__r7cl3","unorderedList":"RichText_unorderedList__a3Vzz"};